"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
const Disposable_1 = require("./Disposable");
const SliceList_1 = require("./SliceList");
/**
 * @deprecated
 * Use Emitter instead
 */
class EventEmitter extends Disposable_1.Disposable {
    registeredListeners = {};
    _on;
    constructor() {
        super();
        this.onWillDispose(() => {
            this.registeredListeners = {};
        });
    }
    // This is a trick that allows us to reference "on" directly
    // and still bind it to the instance
    get on() {
        if (!this._on) {
            this._on = (type, listener) => {
                if (!this.registeredListeners[type]) {
                    this.registeredListeners[type] = new SliceList_1.SliceList();
                }
                const idx = this.registeredListeners[type].add(listener);
                const disposable = {
                    dispose: () => {
                        if (this.registeredListeners[type]) {
                            this.registeredListeners[type].remove(idx);
                        }
                    },
                };
                return disposable;
            };
        }
        return this._on;
    }
    onType(type) {
        return this.on.bind(this, type);
    }
    emit(type, data) {
        if (!this.registeredListeners[type]) {
            return;
        }
        for (const listener of this.registeredListeners[type].values()) {
            listener(data);
        }
    }
    emitType(type) {
        return this.emit.bind(this, type);
    }
}
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXZlbnRFbWl0dGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0V2ZW50RW1pdHRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSw2Q0FBMEM7QUFDMUMsMkNBQXdDO0FBV3hDOzs7R0FHRztBQUNILE1BQWEsWUFBMEMsU0FBUSx1QkFBVTtJQUMvRCxtQkFBbUIsR0FFdkIsRUFBRSxDQUFDO0lBQ0MsR0FBRyxDQUErQjtJQUUxQztRQUNFLEtBQUssRUFBRSxDQUFDO1FBRVIsSUFBSSxDQUFDLGFBQWEsQ0FBQyxHQUFHLEVBQUU7WUFDdEIsSUFBSSxDQUFDLG1CQUFtQixHQUFHLEVBQUUsQ0FBQztRQUNoQyxDQUFDLENBQUMsQ0FBQztJQUNMLENBQUM7SUFFRCw0REFBNEQ7SUFDNUQsb0NBQW9DO0lBQ3BDLElBQUksRUFBRTtRQUNKLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLENBQUM7WUFDZCxJQUFJLENBQUMsR0FBRyxHQUFHLENBQUMsSUFBZSxFQUFFLFFBQW1DLEVBQUUsRUFBRTtnQkFDbEUsSUFBSSxDQUFDLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDO29CQUNwQyxJQUFJLENBQUMsbUJBQW1CLENBQUMsSUFBSSxDQUFDLEdBQUcsSUFBSSxxQkFBUyxFQUFFLENBQUM7Z0JBQ25ELENBQUM7Z0JBRUQsTUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLG1CQUFtQixDQUFDLElBQUksQ0FBQyxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQztnQkFDekQsTUFBTSxVQUFVLEdBQWdCO29CQUM5QixPQUFPLEVBQUUsR0FBRyxFQUFFO3dCQUNaLElBQUksSUFBSSxDQUFDLG1CQUFtQixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUM7NEJBQ25DLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUM7d0JBQzdDLENBQUM7b0JBQ0gsQ0FBQztpQkFDRixDQUFDO2dCQUVGLE9BQU8sVUFBVSxDQUFDO1lBQ3BCLENBQUMsQ0FBQztRQUNKLENBQUM7UUFFRCxPQUFPLElBQUksQ0FBQyxHQUFHLENBQUM7SUFDbEIsQ0FBQztJQUVELE1BQU0sQ0FDSixJQUFPO1FBRVAsT0FBTyxJQUFJLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFRLENBQUM7SUFDekMsQ0FBQztJQUVELElBQUksQ0FDRixJQUFPLEVBQ1AsSUFBeUQ7UUFFekQsSUFBSSxDQUFDLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDO1lBQ3BDLE9BQU87UUFDVCxDQUFDO1FBRUQsS0FBSyxNQUFNLFFBQVEsSUFBSSxJQUFJLENBQUMsbUJBQW1CLENBQUMsSUFBSSxDQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUsQ0FBQztZQUMvRCxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDakIsQ0FBQztJQUNILENBQUM7SUFFRCxRQUFRLENBQ04sSUFBTztRQUVQLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBUSxDQUFDO0lBQzNDLENBQUM7Q0FDRjtBQS9ERCxvQ0ErREMifQ==